import React, { createContext, useCallback, useContext, useMemo } from 'react'

import { node, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import useEligibleModels from '../Hooks/useEligibleModels'
import useTabNavigation from '../Hooks/useTabNavigation'

const SubscriptionsContext = createContext(null)

export function SubscriptionsProvider({ children, locale = 'en' }) {
  const {
    eligibleModels,
    isLoading: isLoadingEligible,
    paginationMeta: eligiblePaginationMeta,
    filters: eligibleFilters,
    setFilters: setEligibleFilters,
    hasFetched: hasFetchedEligible,
  } = useEligibleModels()

  const { activeTab, handleTabChange } = useTabNavigation()

  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  const value = useMemo(
    () => ({
      activeTab,
      handleTabChange,
      translate,

      eligibleModels,
      isLoadingEligible,
      hasFetchedEligible,
      eligiblePaginationMeta,
      eligibleFilters,
      setEligibleFilters,
    }),
    [
      activeTab,
      handleTabChange,
      translate,
      eligibleModels,
      isLoadingEligible,
      hasFetchedEligible,
      eligiblePaginationMeta,
      eligibleFilters,
      setEligibleFilters,
    ],
  )

  return <SubscriptionsContext.Provider value={value}>{children}</SubscriptionsContext.Provider>
}

SubscriptionsProvider.propTypes = {
  children: node.isRequired,
  locale: string,
}

export function useSubscriptionsContext() {
  const context = useContext(SubscriptionsContext)
  if (!context) {
    throw new Error('useSubscriptionsContext must be used within a SubscriptionsProvider')
  }
  return context
}
